import { useRedux } from '../../../../hooks';
import { timespentAdminViewAll, timespentUserCreate } from '../../../../redux/user/logs/timespent/actions';
import { TimespentNew } from '../../../../types/user/logs/timespent';

export default function useTimespentLog() {
    const { dispatch, appSelector } = useRedux();
    const { apiSuccess, adminAllTimespentLogs, loading } = appSelector((state) => ({
        apiSuccess: state.TimespentLog.apiSuccess,
        adminAllTimespentLogs: state.TimespentLog.adminAllTimespentLogs,
        loading: state.TimespentLog.loading,
    }));

    const adminLoadAllTimespentLogs = (page: number, size: number) => {
        dispatch(timespentAdminViewAll(page, size));
    };

    const userCreateTimespent = (data: TimespentNew) => {
        dispatch(timespentUserCreate(data));
    };

    return {
        loading,
        adminAllTimespentLogs,
        apiSuccess,
        userCreateTimespent,
        adminLoadAllTimespentLogs,
    };
}
